<template>
  <span class="boss-title-small">
    <template v-for="(breadcrumb, i) in breadcrumbs">
      <router-link
        v-if="breadcrumb.pathName"
        :key="i"
        :to="{ name: breadcrumb.pathName }"
        :data-test="`breadcrumb-router-${i}`"
      >{{ breadcrumb.name }}{{ joinFormat(i) }}</router-link>
      <span
        v-else
        :key="i"
      >{{ breadcrumb.name }}{{ joinFormat(i) }}
      </span>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  methods: {
    joinFormat (index) {
      return this.breadcrumbs.length - 1 > index ? '/' : ''
    }
  }
}
</script>
